import { Text, TextProps } from '@chakra-ui/react'
import React from 'react'

export default function MissingText({ children, ...props }: TextProps) {
    return (
        <Text fontSize="14px" color="gray.400" fontStyle="italic" {...props}>
            {children}
        </Text>
    )
}
